import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

// @material-ui
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core'
import { withStyles } from '@material-ui/styles'

// core
import { withLang } from '_core/hocs/withLang'
import GrayLink from '_core/components/GrayLink/GrayLink'
import { getVisitorPhotoSrc } from '_core/utils/getVisitorPhotoSrc'

// style
import { articleListItemStyle } from './articleListItemStyle'

const RawArticleListItem = props => {
  const { data, classes, baseUrl, hasActions, hasDate, getLangString: l } = props

  const button = <GrayLink title={l('r.podrobnee')} />

  const content = (
    <>
      {data.photo.id !== 0 ? (
      
        <CardMedia component="img" image={getVisitorPhotoSrc(data.photo.path, 'shop')} title={data.title} className={classes.imageBg} />
      ) : null}

      <CardContent>
        {data.title != null ? (
          <Typography
            gutterBottom
            color="textPrimary"
            variant="body1"
            component="h2"
          >
            {data.title}
          </Typography>
        ) : null}

        {data.description != null ? (
          <Typography variant="body2" color="textSecondary" component="p">
            {data.description}
          </Typography>
        ) : null}
      </CardContent>
    </>
  )

  const renderLink = children =>
    data.link_replaced ? (
      <a target="_blank" rel="noopener noreferrer" href={data.link}>
        {children}
      </a>
    ) : (
      <Link to={`${baseUrl}/${data.name != null ? data.name : data.id}`}>
        {children}
      </Link>
    )

  return (
    <Card style={{flexGrow:'1'}}>
      <CardActionArea style={{height:'100%'}}>
        {hasActions ? renderLink(content) : content}
      </CardActionArea>

      {hasActions ? (
        <CardActions>
          {hasDate ? <Typography variant="caption">{data.time.date}</Typography> : null}

          {renderLink(button)}
        </CardActions>
      ) : null}
    </Card>
  )
}

RawArticleListItem.defaultProps = {
  hasActions: true,
  hasDate: false,
}

RawArticleListItem.propTypes = {
  // self props
  hasActions: PropTypes.bool,
  hasDate: PropTypes.bool,
  data: PropTypes.object.isRequired,
  baseUrl: PropTypes.string.isRequired,

  // `withStyles` HOC props
  classes: PropTypes.object.isRequired,

  // `withLang` HOC props
  langInfo: PropTypes.object,
  getLangObject: PropTypes.func,
  getFirstLangString: PropTypes.func,
  getLangStringSet: PropTypes.func,
  getLangString: PropTypes.func.isRequired,
}

export const ArticleListItem = withLang(
  withStyles(articleListItemStyle)(RawArticleListItem)
)
